import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { BN, web3 } from '@coral-xyz/anchor';
import { Flags } from '@oclif/core';
import { State } from '@switchboard-xyz/on-demand';

const LUT_PID = new web3.PublicKey(
  'AddressLookupTab1e1111111111111111111111111'
);

function deriveLookupTableAddress(
  programId: web3.PublicKey,
  authorityAddress: web3.PublicKey,
  recentBlockSlot: BN
): [web3.PublicKey, number] {
  // Convert slot number (BN) to Little Endian byte array (8 bytes)
  const slotBuffer = recentBlockSlot.toArrayLike(Buffer, 'le', 8);

  // Find Program Derived Address (PDA)
  return web3.PublicKey.findProgramAddressSync(
    [authorityAddress.toBuffer(), slotBuffer],
    programId
  );
}

export default class OracleResetLut extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Reset lut of oracle account';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    oracle: Flags.string({
      description: 'public key of the oracle account',
      required: true,
    }),
  };

  static args = {};

  async run() {
    const { flags } = await this.parse(
      this.constructor as typeof OracleResetLut
    );

    console.log(`# RPC - connection to ${this.connection.rpcEndpoint}`);

    const program = await this.program;

    const stateKey = State.keyFromSeed(program);
    const oracle = new web3.PublicKey(flags.oracle);
    const lutSigner = web3.PublicKey.findProgramAddressSync(
      [Buffer.from('LutSigner'), oracle.toBuffer()],
      program.programId
    )[0];

    const recentSlot = await this.connection.getSlot('finalized');
    const [lut] = deriveLookupTableAddress(
      LUT_PID,
      lutSigner,
      new BN(recentSlot)
    );

    console.log(
      `# creating lut ${lut} with signer ${lutSigner}  with slot ${recentSlot}`
    );
    const ix = program.instruction.oracleResetLut(
      {
        recentSlot: new BN(recentSlot.toString()),
      },
      {
        accounts: {
          oracle: oracle,
          authority: this.keypair.publicKey,
          payer: this.keypair.publicKey,
          systemProgram: web3.SystemProgram.programId,
          programState: stateKey,
          lutSigner,
          lut,
          addressLookupTableProgram: web3.AddressLookupTableProgram.programId,
        },
      }
    );

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, '# ORACLE - failed sync lut tx');
  }
}
